module.exports = __webpack_public_path__ + "static/AvenirNext-Regular-b3b225b811867228654e27ca8f5c5b22.woff";